<!--
动画流程: title, nav, list 在进入窗口范围后分别以 1s 的速度从下向上淡入
-->
<template>
  <div id="js-history" :class="$style.history">
    <div id="js-history-wrap" :class="$style.history_wrap">
      <div id="js-history-title">
        <the-history-title class="app-fadeInUp" />
      </div>
      <div id="js-history-nav" style="margin-top: 0.8rem;">
        <the-history-nav
          :active="String(navActive)"
          :years="navData"
          class="app-fadeInUp"
          @click="onClick"
        />
      </div>
      <div id="js-history-list" style="margin-top: 1.06rem;">
        <base-swiper
          ref="swiper"
          :data="listData"
          :slides-per-view="'auto'"
          simulate-touch
          free-mode
          :loop="false"
          :slide-change="handleChange"
          :class="[$style.swiper, 'app-fadeInUp']"
        >
          <template v-slot:default="slotProps">
            <the-history-list :data="slotProps.el" />
          </template>
        </base-swiper>
      </div>
    </div>
  </div>
</template>

<script>
import aboutMixins from '@/assets/js/aboutMixins'
import BaseSwiper from '../BaseSwiper'
import TheHistoryTitle from './TheHistoryTitle'
import TheHistoryNav from './TheHistoryNav'
import TheHistoryList from './TheHistoryList'

export default {
  components: { BaseSwiper, TheHistoryTitle, TheHistoryNav, TheHistoryList },
  mixins: [aboutMixins],
  props: {
    data: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      name: 'history',
      animateScenesData: ['title', 'nav', 'list'],
      navActive: '',
    }
  },
  computed: {
    navData() {
      return (this.data && this.data.nav) || []
    },
    listData() {
      return (this.data && this.data.list) || []
    },
  },
  mounted() {
    this.navActive = (this.data && this.data.nav && this.data.nav[0]) || ''
  },
  methods: {
    onClick(year) {
      const index = this.listData.findIndex((el) => el.year === year)
      this.$refs.swiper.slideTo(index < 0 ? 0 : index)
    },
    handleChange(swiper) {
      const year = this.listData[swiper.activeIndex].year

      // 当前为倒数第二个年份时, 默认激活年份导航中的最后一年
      if (swiper.activeIndex === this.listData.length - 2) {
        this.navActive = this.navData[this.navData.length - 1]
      }

      // 在年份导航中
      else if (this.navData.includes(year)) {
        this.navActive = year
      }

      // 不在年份导航中
      else {
        const index = this.navData.findIndex((el) => Number(year) > Number(el))
        this.navActive = this.navData[index - 1]
      }
    },
  },
}
</script>

<style lang="less" module>
.history {
  background-color: #f8f8f8;
  user-select: none;

  &_wrap {
    padding: @padding-base-title 0;
    background-color: #f8f8f8;
  }
}

.swiper {
  width: 12.48rem;
  margin: 0 auto;
  overflow: visible;

  :global(.swiper-slide) {
    width: 50%;
  }

  @media screen and (max-width: @tablet-width) {
    width: 15.48rem;

    :global(.swiper-slide) {
      width: 100%;
    }
  }
}
</style>
